
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CustomerPage from '../pages/customer/page';
import KasirPage from '../pages/kasir/page';
import DapurPage from '../pages/dapur/page';
import AdminPage from '../pages/admin/page';
import LoginPage from '../pages/login/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/customer',
    element: <CustomerPage />
  },
  {
    path: '/kasir',
    element: <KasirPage />
  },
  {
    path: '/dapur',
    element: <DapurPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
